module.exports = __webpack_public_path__ + "static/media/black-slash.d909969e.svg";